import { __rest } from "tslib";
import * as React from 'react';
import { TableContext } from '@patternfly/react-table';
import { Body } from '../Body';
export const editableTableBody = (BodyComponent) => {
    const InlineEditBody = (_a) => {
        var { editConfig = null, onRowClick = () => { } } = _a, props = __rest(_a, ["editConfig", "onRowClick"]);
        return (React.createElement(TableContext.Consumer, null, (_a) => {
            var { rows } = _a, consumedProps = __rest(_a, ["rows"]);
            return (React.createElement(Body, Object.assign({}, consumedProps, { rows: rows }, props, { editConfig: editConfig, onRowClick: onRowClick, BodyComponent: BodyComponent })));
        }));
    };
    return InlineEditBody;
};
//# sourceMappingURL=editableTableBody.js.map